
import TncCategory from './routes/category/TncCategory.vue';
import createTncCategory from './routes/category/component/createTncCategory.vue';
import editTncCategory from './routes/category/component/editTncCategory.vue';

import TncContent from './routes/content/TncContent.vue';
import createTncContent from './routes/content/component/createTncContent.vue';
import editTncContent from './routes/content/component/editTncContent.vue';

const TncRoutes = [
    {
        path: '/tnc-content',
        name: 'TncContent',
        component: TncContent,
    },
    {
        path: '/create-tnc-content',
        name: 'createTncContent',
        component: createTncContent,
    },
    {
        path: '/edit-tnc-content/:id',
        name: 'editTncContent',
        component: editTncContent,
    },
    {
        path: '/tnc-category',
        name: 'TncCategory',
        component: TncCategory,
    },
    {
        path: '/create-tnc-category',
        name: 'createTncCategory',
        component: createTncCategory,
    },
    {
        path: '/edit-tnc-category/:id',
        name: 'editTncCategory',
        component: editTncCategory,
    },
];

export default TncRoutes;
